import { useLayoutEffect } from "react";
import type { RefObject } from "react";

import { readValue, renderValue } from "./utils";

import type { MentionOption } from "./types";

const useSyncedMentionValue = (
  editorRef: RefObject<HTMLDivElement>,
  value: string,
  mentions: MentionOption[],
  mask?: string
) => {
  useLayoutEffect(() => {
    const editor = editorRef.current;

    if (editor && readValue(editor) !== value) {
      renderValue(editor, value, mentions, mask);
    }
  }, [editorRef, mask, mentions, value]);
};

export default useSyncedMentionValue;
